import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { arrayMove } from '@dnd-kit/sortable';

// Hook to manage dnd on cards
export default function useEditionDndActions(cards, { onReorder } = {}) {
  const [items, setItems] = useState(cards);
  const [activeId, setActiveId] = useState(null);
  const pendingReorderRef = useRef(null);

  useLayoutEffect(() => {
    setItems(cards);
  }, [cards]);

  useEffect(() => {
    if (!onReorder) return;

    const pending = pendingReorderRef.current;
    if (!pending) return;

    pendingReorderRef.current = null;
    onReorder(pending);
  }, [items, onReorder]);

  const activeItem = useMemo(
    () => items.find((item) => item.id === activeId) || null,
    [items, activeId]
  );

  const onDragStart = ({ active }) => {
    setActiveId(active?.id ?? null);
  };

  const onDragEnd = ({ active, over }) => {
    setActiveId(null);
    if (!over || active.id === over.id) return;
    setItems((current) => {
      const oldIndex = current.findIndex((item) => item.id === active.id);
      const newIndex = current.findIndex((item) => item.id === over.id);
      if (oldIndex < 0 || newIndex < 0) return current;

      const nextItems = arrayMove(current, oldIndex, newIndex);
      pendingReorderRef.current = nextItems;
      return nextItems;
    });
  };

  const onDragCancel = () => {
    setActiveId(null);
  };

  return { items, activeItem, onDragStart, onDragEnd, onDragCancel };
}
